import type { CSSProperties } from "react";
import { NavLink } from "react-router-dom";
import { SCREENS } from "@/admin/catalog";

const WRAP: CSSProperties = {
  display: "flex",
  gap: 8,
  overflowX: "auto",
  padding: "12px 24px",
  scrollbarWidth: "none",
};
const PILL_BASE: CSSProperties = {
  flexShrink: 0,
  borderRadius: 999,
  padding: "8px 14px",
  fontFamily: "var(--font-body)",
  fontSize: 13,
  textDecoration: "none",
  border: "1px solid var(--d-violet)",
  color: "var(--d-violet)",
  background: "transparent",
  whiteSpace: "nowrap",
};
const PILL_ACTIVE: CSSProperties = {
  ...PILL_BASE,
  background: "var(--d-violet)",
  color: "var(--d-ink)",
};

/** Six screens from the catalog, in catalog order. Labels are English by design. */
export function AdminTabs(): JSX.Element {
  return (
    <nav style={WRAP} aria-label="Admin screens">
      {SCREENS.map((screen) => (
        <NavLink
          key={screen.id}
          to={screen.path}
          style={({ isActive }) => (isActive ? PILL_ACTIVE : PILL_BASE)}
        >
          {screen.name}
        </NavLink>
      ))}
    </nav>
  );
}
